import { Box, Link } from "@mui/material";
import penIcon from "assets/images/icons/pen.svg";

const FEEDBACK_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSdWKBbvUQgCFYPqw5-Xq6XRTfSPnAZq5SFE0uPuTrpsa-46wA/viewform?usp=publish-editor";

const FeedbackButton = () => {
  return (
    <Link
      href={FEEDBACK_FORM_URL}
      target="_blank"
      rel="noopener noreferrer"
      underline="none"
      aria-label="Open feedback form"
      sx={{
        position: "fixed",
        right: { xs: 16, sm: 20, md: 24 },
        bottom: { xs: 38, sm: 44, md: 52 },
        zIndex: 1350,
        display: "inline-flex",
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 1,
          px: 2.2,
          py: 1.15,
          borderRadius: "999px",
          color: "#111111",
          background: "#ffffff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
          transition: "transform 160ms ease, box-shadow 160ms ease",
          "&:hover": {
            transform: "translateY(-1px)",
            boxShadow: "0 4px 12px rgba(0,0,0,0.14)",
          },
        }}
      >
        <Box
          component="img"
          src={penIcon}
          alt=""
          aria-hidden="true"
          sx={{
            width: 19,
            height: 19,
            filter: "brightness(0) saturate(100%)",
            flex: "0 0 auto",
          }}
        />
        <Box
          component="span"
          sx={{
            fontSize: "1rem",
            fontWeight: 700,
            lineHeight: 1,
            color: "#111111",
          }}
        >
          Feedback
        </Box>
      </Box>
    </Link>
  );
};

export default FeedbackButton;
